angular.module('unergie.main')
.controller('staggerPaymentModalCtrl', ($scope, $uibModalInstance, AdminComments, DataAccess, MetaWatcher, AlertManager, ErrorCatcher, AuthService, BoFeaturesService, MS, payment, contract) => {
    $scope.initialPayment = angular.copy(payment)
    const feats = BoFeaturesService.getModuleFeatures('contracts')
    $scope.freePaymentNumber = feats.staggerNoLimit

    $scope.newPayments = [{ amount: $scope.initialPayment.amount, payment_date: moment($scope.initialPayment.payment_date).format('DDMMYYYY') }]

    $scope.nbPayments = 1

    $scope.min = 1
    $scope.max = $scope.initialPayment.amount
    $scope.paymentNumbers = [1, 2, 3, 4, 6]

    if (feats.canViewStaggerMonths) {
        $scope.paymentNumbers = _.concat($scope.paymentNumbers, [9, 12])
    }
    const sum = () => {
        $scope.sumPayment = MS.round(_.sumBy($scope.newPayments, (p) => Number(p.amount)), 2)
    }

    $scope.updateNbPayments = () => {
        $scope.newPayments = []
        const date = moment($scope.initialPayment.payment_date)
        for (let i = 0; i < $scope.nbPayments; i += 1) {
            $scope.newPayments.push({
                id: i,
                payment_date: date.format('DDMMYYYY'),
                amount: MS.round($scope.initialPayment.amount / $scope.nbPayments, 2),
            })
            date.add(1, 'month')
        }
        $scope.newPayments[0].amount = MS.round(($scope.newPayments[0].amount + $scope.initialPayment.amount) - _.sumBy($scope.newPayments, 'amount'), 2)
        sum()
    }

    $scope.onChangeDate = (changedPayment) => {
        if (changedPayment.payment_date) {
            const date = moment(changedPayment.payment_date, 'DDMMYYYY').format('YYYY-MM-DD')
            if (moment(date).isValid()) {
                $scope.initialPayment.payment_date = date
                $scope.updateNbPayments()
            }
        }
    }

    $scope.isDateValid = (date) => {
        return moment(moment(date, 'DDMMYYYY').format('YYYY-MM-DD')).isValid()
    }


    $scope.amountChanged = (p) => {
        p.amount = Number(p.amount)
        if (p.amount > $scope.max) {
            p.amount = $scope.max
        } else if (p.amount < $scope.min) {
            p.amount = $scope.min
        }
        let totalAssigned = Number(p.amount)
        _.each(_.orderBy($scope.newPayments, 'id', 'asc'), (np) => {
            if (np.id < p.id) {
                totalAssigned += Number(np.amount)
            }
            let leftToAssign = $scope.initialPayment.amount - totalAssigned
            if ((np.id === p.id) && (leftToAssign < 0)) {
                np.amount += leftToAssign
                leftToAssign = 0
            }
            const nbLeftToAssign = $scope.nbPayments - np.id
            if (np.id > p.id) {
                const newAmount = MS.round(leftToAssign / nbLeftToAssign, 2)
                np.amount = newAmount
                totalAssigned += newAmount
            }
            np.amount = MS.round(Math.max(np.amount, 0), 2)
        })
        sum()
    }

    $scope.close = $uibModalInstance.dismiss

    $scope.ok = () => {
        $scope.staggering = true
        const payload = _.map($scope.newPayments, (p) => {
            return {
                payment_date: moment(p.payment_date, 'DDMMYYYY').format('YYYY-MM-DD'),
                amount: p.amount,
            }
        })
        return DataAccess.staggerPayment({ id_payment: $scope.initialPayment.id }, payload).$promise.then((results) => {
            AlertManager.success('Paiement échelonné avec succès')
            let comment = `<b>AUTOMATIQUE</b>`
            if (payment.id) {
                comment += ` : Échelonnement Plüm, paiement id: <b>${payment.id}</b> (${moment(payment.payment_date).format('DD MMM YYYY')} - ${payment.amount} €) échelonné :`
            } else {
                comment += ` : Paiement(s) de recouvrement généré(s) :`
            }
            _.each($scope.newPayments, (p) => {
                comment += `<br><b>${moment(p.payment_date, 'DDMMYYYY').format('DD MMM YYYY')}</b> : <b>${p.amount} €</b>`
            })
            AdminComments.addComment({ object: contract.id, comment }).$promise.catch(ErrorCatcher)
            $uibModalInstance.dismiss()
            MetaWatcher.notif('PAYMENT_CHANGED', contract)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.staggering = false
        })
    }
})
